module.exports = __webpack_public_path__ + "img/wx.6678fe5.svg";